module.exports = __webpack_public_path__ + "static/postIt05-d6f6d7cbd409684b9984540eac600a66.svg";